import { createBrowserRouter } from "react-router-dom";

import { ErrorBoundaryRoot } from "@components/ErrorBoundary/Root";
import { PageGuard } from "@components/PageGuard";
import { PageLayout } from "@components/PageLayout";
import { PageLayoutProtected } from "@components/PageLayoutProtected";
import { PageProgress } from "@components/PageProgress";
import { ProvidersAndConfigs } from "@components/ProvidersAndConfigs";

const protectedRoutes = [
  {
    path: "/servicos",
    lazy: () => import("@pages/Services"),
  },
  {
    path: "/termos-de-uso",
    lazy: () => import("@pages/Terms"),
  },
  {
    path: "/politica-de-privacidade",
    lazy: () => import("@pages/PrivacyPolicy"),
  },
  {
    path: "/contratos/:token_contrato?",
    lazy: () => import("@pages/Contracts"),
  },
  {
    path: "/cartao/cartao-beneficio",
    lazy: () => import("@pages/journeys/BenefitCard"),
  },
  // {
  //   path: "/saque-complementar",
  //   lazy: () => import("@pages/journeys/BenefitCardWithdrawal"),
  // },
  {
    path: "/cartao/agregacao-margem",
    lazy: () => import("@pages/journeys/AggregationMarginCard"),
  },
  {
    path: "/consignado/consignado-privado/:idProposta?",
    lazy: () => import("@pages/journeys/PrivateCredit"),
  },
  {
    path: "/consignado/acompanhamento-proposta",
    lazy: () => import("@pages/ProposalTracking"),
  },
  {
    path: "/consignado/consignado-privado/:idProposta?/:step?",
    lazy: () => import("@pages/journeys/PrivateCredit"),
  },
  {
    path: "/nao-me-perturbe",
    lazy: () => import("@pages/NotDisturbeMe"),
  },
  {
    path: "/notificacoes/:notification_id?",
    lazy: () => import("@pages/Notifications"),
  },
  {
    path: "/usuarios/:token_usuario?",
    lazy: () => import("@pages/Users"),
  },
  {
    path: "/usuarios/solicitacao/:token_solicitacao?",
    lazy: () => import("@pages/Users/Requests"),
  },
  {
    path: "/usuarios/novo",
    lazy: () => import("@pages/Users/NewUser"),
  },
];

export const router = createBrowserRouter(
  [
    {
      element: <ProvidersAndConfigs />,
      children: [
        {
          element: <PageProgress />,
          children: [
            {
              path: "",
              element: <PageGuard />,
              errorElement: <ErrorBoundaryRoot />,
              children: [
                {
                  element: <PageLayout />,
                  children: [
                    {
                      path: "/login",
                      lazy: () => import("@pages/auth/Login"),
                    },
                    {
                      path: "/esqueci-senha",
                      lazy: () => import("@pages/auth/ForgotPassword"),
                    },
                    {
                      path: "/nova-senha",
                      lazy: () => import("@pages/auth/ResetPassword"),
                    },
                    {
                      path: "/reset-password/:uid/:token",
                      lazy: () => import("@pages/auth/ResetPassword"),
                    },
                    {
                      path: "/validacao",
                      lazy: () => import("@pages/auth/Validation"),
                    },
                    {
                      path: "/selecao-corban",
                      lazy: () => import("@pages/CorbanSelect"),
                    },
                    {
                      path: "*",
                      lazy: () => import("@pages/fallbacks/NotFound"),
                    },
                    {
                      path: "/sem-acesso",
                      lazy: () => import("@pages/fallbacks/NotAllowed"),
                    },
                  ],
                },
                {
                  element: <PageLayoutProtected />,
                  children: protectedRoutes,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  {
    future: {
      v7_normalizeFormMethod: true,
    },
  },
);
